const blockClass = '.wp-block-acf-global-header';
const navContainer = '.wp-block-navigation__responsive-container';
const modalCloseButton = '.wp-block-navigation__responsive-container-close';

// Global Header - Swiper slide navigation
($ => {
    const $header = $(blockClass);
    const $navContainer = $header.find(navContainer);
    const $modalCloseButton = $(modalCloseButton);

    console.log($modalCloseButton);
    
    if (!$header.length) return;
    
    // Get nav links that target anchors (format: #home, #contact, etc.)
    const $navLinks = $header.find('a[href^="#"]').filter(function() {
        const href = $(this).attr('href');
        return href && href !== '#';
    });
    
    if (!$navLinks.length) return;
    
    // Helper to get the first available swiper instance and its slide map
    const getSwiperData = () => {
        const instances = window.swiperInstances || {};
        const slideMaps = window.swiperSlideMap || {};
        const keys = Object.keys(instances);
        if (!keys.length) return null;
        return {
            swiper: instances[keys[0]],
            slideMap: slideMaps[keys[0]] || {}
        };
    };
    
    // Get slide index from anchor href (e.g., "#home" -> index from slideMap)
    const getSlideIndex = (href) => {
        const data = getSwiperData();
        if (!data) return null;
        const id = href.replace('#', '');
        return data.slideMap[id] !== undefined ? data.slideMap[id] : null;
    };
    
    // Update active nav link based on current section
    const updateActiveNav = (activeSection) => {
        $navLinks.removeClass('is-active');
        if (activeSection) {
            $navLinks.filter(`[href="#${activeSection}"]`).addClass('is-active');
        }
    };
    
    // Handle nav link clicks - navigate to slide
    $header.on('click', 'a[href^="#"]', function(e) {
        const href = $(this).attr('href');
        if (!href || href === '#') return;
        
        const slideIndex = getSlideIndex(href);
        if (slideIndex === null) return;
        
        e.preventDefault();
        
        const data = getSwiperData();
        if (!data) return;
        
        // Close modal nav menu if open
        if ($navContainer.hasClass('is-menu-open')) {
            $modalCloseButton.trigger('click');
        }
        
        // Navigate to the slide
        data.swiper.slideTo(slideIndex);

        // Stop autoplay when user manually navigates
        data.swiper.autoplay.stop();
    });
    
    // Listen for swiper slide changes to update active nav
    window.addEventListener('swiperSlideChange', (e) => {
        updateActiveNav(e.detail.activeSection);
    });
    
    // Set initial active state when swiper initializes
    window.addEventListener('swiperInit', (e) => {
        updateActiveNav(e.detail.activeSection);
    });
    
    // Also check if swiper already initialized before this script ran
    $(document).ready(() => {
        const data = getSwiperData();
        if (data && data.swiper) {
            const $slides = $(data.swiper.el).find('.swiper-slide');
            const $activeSlide = $slides.eq(data.swiper.realIndex);
            updateActiveNav($activeSlide.data('section') || $activeSlide.attr('id') || null);
        }
    });

})(jQuery);
